var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    container: {
        padding: '16px',
    },
    yearLabel: {
        fontSize: '18px',
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: '16px',
        color: '#323130',
    },
    grid: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-around',
        gap: '8px',
    },
    monthCell: {
        flex: 1,
        padding: '12px 8px',
        border: 'none',
        borderRadius: '4px',
        backgroundColor: 'transparent',
        fontSize: '14px',
        fontWeight: 400,
        color: '#323130',
        cursor: 'pointer',
        transition: 'all 0.1s ease',
        textAlign: 'center',
    },
    monthDisabled: {
        color: '#a19f9d',
        cursor: 'not-allowed',
        opacity: 0.5,
    },
    monthCurrent: {
        fontWeight: 600,
        color: '#0078d4',
    },
    monthSelected: {
        backgroundColor: '#0078d4',
        color: '#ffffff',
        fontWeight: 600,
    },
};
export default styles;
//# sourceMappingURL=MonthPicker.styles.js.map